import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useContextApi } from "../context/ContextApi";
import { useShowAlert } from "../context/AlertContext";
import { CloseBxIcon, TrashIcon, XIcon } from "./Icons";

const DeleteModal = ({
  onClose,
  onConfirm,
  isLable,
  isBtnLoading,
  showConfirmCheckbox = false,
}) => {
  const showAlert = useShowAlert();
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);

  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleDelete = () => {
    if (showConfirmCheckbox && !isConfirmed) {
      showAlert(
        "warning",
        "Please tick the confirmation checkbox before deleting.",
      );
      return;
    }

    onConfirm();
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show"
        id="DeleteModal"
        aria-modal="true"
        role="dialog"
        onClick={onClose}
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-md modal-dialog-scrollable"
          onClick={stopPropagation}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="modal-content border-0">
            <div
              className="modal-header"
              style={{ backgroundColor: "#e11900" }}
            >
              <h5 className="modal-title" style={{ color: "#ffffff" }}>
                Confirm Deletion
              </h5>

              <button
                type="button"
                onClick={onClose}
                className="btn-close-white"
                style={{ color: "#ffffff" }}
              >
                <CloseBxIcon />
              </button>
            </div>

            <div className="modal-body">
              <p className="mb-2">
                Are you sure you want to delete this <strong>{isLable}</strong>?
                <br />
                This action cannot be undone.
              </p>

              {showConfirmCheckbox && (
                <div className="form-check mt-3 justify-content-center d-flex gap-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="deleteConfirm"
                    checked={isConfirmed}
                    onChange={(e) => setIsConfirmed(e.target.checked)}
                  />
                  <label
                    className="form-check-label fw-semibold"
                    htmlFor="deleteConfirm"
                  >
                    As Confirm
                  </label>
                </div>
              )}
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-outline-secondary"
              >
                <XIcon iClass={"font-20"} /> Cancel
              </button>

              {isBtnLoading ? (
                <button className="btn btn-danger pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger"
                >
                  <TrashIcon iClass={"font-20"} /> Delete
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
